import { rootPaths } from "pages/routes";
import { FC } from "react";
import { Link } from "react-router-dom";
import useUserData from "repository/useUser";

/**
 * # できる必要があること
 * - MUST[ ] 店舗作成
 * - MUST[ ] 店舗アカウント作成
 * - BETTER[ ] 各店舗の権限確認
 * - BETTER[ ] 各アカウントの権限確認
 *  */

type Props = {};
const AdminIndexPage: FC<Props> = () => {
  const { data, isLoading, isError } = useUserData();
  if (isLoading) return <p>loading</p>;
  if (isError || !data) return <p>エラーが起きました</p>;
  if (data.isAdmin !== true) return <p>権限がありません</p>;
  return (
    <div>
      <h1>管理ページ</h1>
      <Link to={rootPaths.dashboard}>ダッシュボードへ</Link>
    </div>
  );
};
export default AdminIndexPage;
